import React from 'react';
import ErrorPage from '@/components/ErrorPage';
import { IconButton } from 'rsuite';
import ArrowLeftLine from '@rsuite/icons/ArrowLeftLine';

export default () => (
  <ErrorPage code={404}>
    {/* <p className="error-page-title">Oops… You just found an error page</p> */}
    <p className="error-page-title">Oops… You are not authorize for this page</p>
    <p className="error-page-subtitle text-muted ">
      We are sorry but the page you are looking for was not found
    </p>
    {/* <IconButton icon={<ArrowLeftLine />} appearance="primary" href="ug/dashboard">
      Take me home
    </IconButton> */}
  </ErrorPage>
);
